var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"point",style:({ transform: `translate(${_vm.pointLeft}px,${_vm.pointTop}px)` }),attrs:{"title":_vm.doc.title},on:{"mousedown":_vm.startDrag,"mouseup":_vm.stopDrag,"mousemove":_vm.onDrag,"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }